import FeaturedDocuments from './featured_documents';
import { initializeChakraComponent } from 'Shared/chakra-initialize';

initializeChakraComponent('FeaturedDocuments', FeaturedDocuments);
